const UPDATE_PERSON = 'UPDATE_PERSON'
const RESET_PERSON = 'RESET_PERSON'

export default {
    UPDATE_PERSON,
    RESET_PERSON
}